(function () {
  'use strict';

  if (window.AlludeAttribution) return;

  var STORAGE_FIRST = 'allude_attr_first';
  var STORAGE_LAST = 'allude_attr_last';
  var LAST_TOUCH_TTL_DAYS = 30;
  var FIRST_TOUCH_TTL_DAYS = 180;

  var TRACKED_PARAMS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
    'fbclid', 'gclid', 'msclkid', 'ttclid', 'awc', 'srsltid'
  ];

  var INTERNAL_REFERRER_HOSTS = [
    'allude-cashmere.com',
    'www.allude-cashmere.com',
    'checkout.shopify.com'
  ];

  function safeLocalStorage() {
    try {
      var k = '__allude_test__';
      localStorage.setItem(k, k);
      localStorage.removeItem(k);
      return localStorage;
    } catch (e) {
      return null;
    }
  }

  var store = safeLocalStorage();
  if (!store) return;

  function getConsentStatus() {
    try {
      var api = window.Shopify?.customerPrivacy;
      if (typeof api?.currentVisitorConsent !== 'function') return 'unknown';
      var c = api.currentVisitorConsent();
      if (!c) return 'unknown';
      var marketing = c.marketing || c.marketing_allowed;
      if (marketing === 'yes') return 'granted';
      if (marketing === 'no') return 'denied';
      return 'pending';
    } catch (e) {
      return 'unknown';
    }
  }

  function subscribeToConsent(cb) {
    try {
      var api = window.Shopify?.customerPrivacy;
      if (typeof api?.subscribe === 'function') {
        api.subscribe('visitorConsentCollected', cb);
      }
    } catch (e) {}
    document.addEventListener('visitorConsentCollected', cb);
  }

  function readUrlParams() {
    var qs = window.location.search;
    if (!qs || qs.length < 2) return null;
    var params = new URLSearchParams(qs);
    var found = {};
    var hasAny = false;
    for (var i = 0; i < TRACKED_PARAMS.length; i++) {
      var key = TRACKED_PARAMS[i];
      var value = params.get(key);
      if (value && value.length <= 255) {
        found[key] = value;
        hasAny = true;
      }
    }
    return hasAny ? found : null;
  }

  function getExternalReferrer() {
    var ref = document.referrer;
    if (!ref) return '';
    try {
      var host = new URL(ref).hostname;
      for (var i = 0; i < INTERNAL_REFERRER_HOSTS.length; i++) {
        if (host === INTERNAL_REFERRER_HOSTS[i]) return '';
      }
      return ref;
    } catch (e) {
      return '';
    }
  }

  function readStored(key, ttlDays) {
    try {
      var raw = store.getItem(key);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed.ts !== 'number') return null;
      var ageDays = (Date.now() - parsed.ts) / 86400000;
      if (ageDays > ttlDays) {
        store.removeItem(key);
        return null;
      }
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function writeStored(key, payload) {
    try {
      store.setItem(key, JSON.stringify(payload));
    } catch (e) {}
  }

  function clearPersisted() {
    try {
      store.removeItem(STORAGE_FIRST);
      store.removeItem(STORAGE_LAST);
    } catch (e) {}
  }

  function buildTouch(params) {
    return {
      ts: Date.now(),
      landing_path: window.location.pathname + window.location.search,
      referrer: getExternalReferrer(),
      params: params
    };
  }

  function flattenTouch(prefix, touch) {
    var out = {};
    if (!touch) return out;
    Object.keys(touch.params).forEach(function (k) {
      out['_' + prefix + '_' + k] = touch.params[k];
    });
    if (touch.landing_path) out['_' + prefix + '_landing'] = touch.landing_path;
    if (touch.referrer) out['_' + prefix + '_referrer'] = touch.referrer;
    out['_' + prefix + '_ts'] = new Date(touch.ts).toISOString();
    return out;
  }

  function syncCart(attributes) {
    if (!window.fetch || Object.keys(attributes).length === 0) return;
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ attributes: attributes })
    }).catch(function () {});
  }

  var pendingTouch = null;

  function persistAndSync() {
    if (pendingTouch) {
      writeStored(STORAGE_LAST, pendingTouch);
      if (!store.getItem(STORAGE_FIRST)) {
        writeStored(STORAGE_FIRST, pendingTouch);
      }
      pendingTouch = null;
    }

    var first = readStored(STORAGE_FIRST, FIRST_TOUCH_TTL_DAYS);
    var last = readStored(STORAGE_LAST, LAST_TOUCH_TTL_DAYS);

    var attrs = {};
    Object.assign(attrs, flattenTouch('first', first));
    Object.assign(attrs, flattenTouch('last', last));

    if (Object.keys(attrs).length > 0) {
      syncCart(attrs);
    }

    exposeApi(first, last, attrs, 'granted');
  }

  function exposeApi(first, last, attrs, consent) {
    window.AlludeAttribution = {
      first: first,
      last: last,
      consent: consent,
      pending: !!pendingTouch,
      resync: function () { if (attrs) syncCart(attrs); },
      clear: clearPersisted
    };
  }

  function waitForPrivacyApi(callback) {
    var attempts = 0;
    var maxAttempts = 50; // 10s at 200ms intervals
    function check() {
      var api = window.Shopify?.customerPrivacy;
      if (typeof api?.currentVisitorConsent === 'function') {
        callback(true);
        return;
      }
      attempts++;
      if (attempts >= maxAttempts) { callback(false); return; }
      setTimeout(check, 200);
    }
    check();
  }

  function handleConsentChange() {
    var status = getConsentStatus();
    if (status === 'granted') {
      persistAndSync();
    } else if (status === 'denied') {
      pendingTouch = null;
      clearPersisted();
      exposeApi(null, null, null, 'denied');
    } else {
      exposeApi(null, null, null, status);
    }
  }

  function run() {
    var current = readUrlParams();
    if (current) {
      pendingTouch = buildTouch(current);
    }

    exposeApi(null, null, null, 'unknown');

    waitForPrivacyApi(function (apiReady) {
      if (!apiReady) return; // no consent framework detected, stay silent
      subscribeToConsent(handleConsentChange);
      handleConsentChange();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
